import { useTasksCloseReasonOptions } from "@coworker/apprestructured/src/shared/hooks/tasks/useTasksCloseReasonOptions";
import { useTasksTypes } from "@coworker/apprestructured/src/shared/hooks/tasks/useTasksTypes";
import { TaskListItem } from "@coworker/apprestructured/src/TasksOverview/hooks/useTasksOverview";
import { useMemo } from "react";

export const useCloseReasonOptions = (
  tasks: TaskListItem[],
  { enabled }: { enabled: boolean }
) => {
  const tasksTypesIds = useMemo(
    () =>
      tasks
        .filter((task) => task.type === "v2")
        .map(({ task_data }) => task_data.task_type_id),
    [tasks]
  );
  const { tasksTypes, isLoading: isLoadingTaskType } = useTasksTypes(
    tasksTypesIds,
    { enabled }
  );

  const shouldFetchCloseReasons = enabled && !isLoadingTaskType;
  const { closeReasonOptions, isLoading: isLoadingCloseReasons } =
    useTasksCloseReasonOptions(tasksTypes, {
      enabled: shouldFetchCloseReasons,
    });

  return {
    closeReasonOptions,
    isLoading: isLoadingTaskType || isLoadingCloseReasons,
  };
};
